export default __webpack_public_path__ + "793fe40248d61cff8872337631d24c91.svg";